<div class="flex items-center justify-center dialog-header">
  {{ type }} Google Configuration
  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

<div class="dialog-content">
  <form [formGroup]="googleConfigForm" (ngSubmit)="submitForm()">
    <div class="p-fluid grid grid-cols-2 gap-6">
      <div class="flex flex-col">
        <label>Email ID *</label>
        <input pInputText formControlName="email_id" class="w-full" />
        <div
          *ngIf="googleConfigForm.get('email_id')?.invalid && (googleConfigForm.get('email_id')?.touched || submitted)"
          class="text-red-500 text-xs mt-1">Valid email is required.</div>
      </div>
    </div>
    <!-- <div class="flex flex-col">
        <label>Date</label>
        <input pInputText type="number" formControlName="date" class="w-full" />
      </div> -->

    <div formGroupName="token_info" class="p-fluid grid grid-cols-2 gap-6">
      <div class="col-span-2 font-semibold mt-4">Token Info</div>

      <div class="flex flex-col">
        <label>Access Token *</label>
        <input pInputText formControlName="access_token" class="w-full" />
      </div>

      <div class="flex flex-col">
        <label>Refresh Token *</label>
        <input pInputText formControlName="refresh_token" class="w-full" />
      </div>


      <div class="flex flex-col">
        <label>Token Type *</label>
        <input pInputText formControlName="token_type" class="w-full" />
      </div>

      <div class="flex flex-col col-span-2">
        <label>Scope *</label>
        <textarea pTextarea formControlName="scope" rows="3" class="w-full"></textarea>
      </div>

      <div class="flex flex-col">
        <label>Expiry Date</label>
        <input pInputText type="number" formControlName="expiry_date" class="w-full" />
      </div>

      <div class="flex flex-col col-span-2">
        <label>ID Token</label>
        <textarea pTextarea formControlName="id_token" rows="3" class="w-full"></textarea>
      </div>


    </div>



    <div formGroupName="google_credential_info" class="p-fluid grid grid-cols-2 gap-6">
      <div class="col-span-2 font-semibold mt-4">Google Credential Info</div>

      <div class="flex flex-col">
        <label>Client ID *</label>
        <input pInputText formControlName="CLIENT_ID" class="w-full" />
      </div>

      <div class="flex flex-col">
        <label>Client Secret *</label>
        <input pInputText type="password" formControlName="CLIENT_SECRET" class="w-full" />
      </div>

      <div class="flex flex-col col-span-2">
        <label>Redirect URI *</label>
        <input pInputText formControlName="REDIRECT_URI" class="w-full" />
      </div>

    </div>

    
    <div class="col-span-2 flex justify-end mt-4">
      <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
        [disabled]="googleConfigForm.invalid || isLoading"></p-button>
    </div>
  </form>
</div>